var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1701_4952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.571415 7.99998C0.571415 12.1027 3.89724 15.4286 7.99999 15.4286C12.1027 15.4286 15.4286 12.1027 15.4286 7.99998C15.4286 3.8973 12.1027 0.571411 7.99999 0.571411C3.89724 0.571411 0.571415 3.8973 0.571415 7.99998Z",
    fill: "#D7E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.571415 7.99998C0.571415 12.1027 3.89724 15.4286 7.99999 15.4286C12.1027 15.4286 15.4286 12.1027 15.4286 7.99998C15.4286 3.8973 12.1027 0.571411 7.99999 0.571411C3.89724 0.571411 0.571415 3.8973 0.571415 7.99998Z",
    stroke: "#4C60E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85712 5.14282L3.99997 7.99996L6.85712 10.8571",
    stroke: "#4C60E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8L12 8",
    stroke: "#4C60E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1701_4952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(0 1 -1 0 16 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleLeft);
export default __webpack_public_path__ + "static/media/arrow-circle-left.afa4e8471bd59aebab233d813c7b74cf.svg";
export { ForwardRef as ReactComponent };